import Layout from "../../components/layout";
import "swagger-ui-react/swagger-ui.css";
import ApiHeader from "../../components/api_page/ApiHeader";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import { useRouter } from "next/router";
import AvailableAPI from "../../components/api_page/AvailableAPI";
import { useState } from "react";
import ApiForm from "../../components/api_page/Form";
import getCommonLocales from "../../locales/locales_common";

export default function ApiAndSdk() {
	const { pathname, locale } = useRouter();
	const [modalWindowIsOpen, setModalWindowIsOpen] = useState(false);

	const openModal = () => setModalWindowIsOpen(true);
	const closeModal = () => setModalWindowIsOpen(false);

	const dictionary = { ...getCommonLocales(locale) };

	const title = dictionary["page_api_title"] || "Bgrem API - Powerful Photo and Video Processing Tools for Developers";
	const description =
		dictionary["page_api_description"] ||
		"Bgrem API offers AI-based tools for content creation and editing : background video removal, photo into painting transformation, interior redesign, and much more.";

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/application-programming-interface/`;
		} else {
			return `https://bgrem.ai/${locale}/application-programming-interface/`;
		}
	};

	return (
		<Layout mainClassName="">
			<OpenGraphTwitterCard title={title} description={description} url={pathname} canonical={getCanonicalLink(locale)} />

			<ApiHeader {...{ openModal, dictionary }} />

			<AvailableAPI {...{ openModal, dictionary }} />
			{modalWindowIsOpen && <ApiForm {...{ closeModal, dictionary }} />}
		</Layout>
	);
}
